import { Box, Divider, Icon, Typography } from '@mui/material'
import { useMutation, useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { getCreditBalance } from 'services/api/modules/recruitment/credit'
import { payWithCredit } from 'services/api/modules/recruitment/order'
import TermAndCondition from './TermAndCondition'
import AdxButton from 'components/custom/AdxButton'

const {
  default: AdxFullWindowTitleBar,
} = require('components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar')

const PaymentPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  //set data
  const data = location.state.data.data
  // CALL API
  const {
    isLoading: creditBalanceIsLoading,
    error: creditBalanceError,
    data: creditBalanceData,
  } = useQuery(
    ['getCreditBalance'],
    async () => {
      const { data } = await getCreditBalance()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const creditBalance = creditBalanceData?.current_credit_balance
  const cartID = data?.price_summary?.cart_prices?.map((list) => list.cart_id)

  const {
    mutate: payWithCreditMutate,
    isSuccess: payWithCreditIsSuccess,
    isLoading: payWithCreditIsLoading,
  } = useMutation((value) => payWithCredit(value), {
    onSuccess: (response) => {
      navigate('/app/recruitment/payment/candidate-purchased/success', {
        state: {
          data: response,
        },
      })
    },

    onError: (error) => {
      navigate('/app/recruitment/payment/candidate-purchased/fail', {
        state: {
          data: error,
        },
      })
    },
  })

  const handlePayment = () => {
    payWithCreditMutate({
      current_balance: creditBalance,
      total_price: data.price_summary.total_price,
      selected_cart_ids: cartID,
    })
  }

  // close button action
  const handleClose = () => {
    navigate('/app/recruitment')
  }
  const returnToCart = () => {
    navigate('/app/recruitment/cart')
  }
  const goToCreditTopUp = () => {
    navigate('/app/recruitment/credit/top-up')
  }
  return (
    <Box bgcolor="gray-background.main" minHeight="100vh">
      <AdxFullWindowTitleBar onClose={handleClose}>Payment Page</AdxFullWindowTitleBar>
      <Box display="flex" justifyContent="center">
        <Box bgcolor="white.main" width={700} px={4} minHeight="calc(100vh - 59px)">
          <Box
            marginTop={4}
            padding={3}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              border: '1px solid',
              borderColor: 'gray-line.main',
            }}
          >
            <Box display="flex" columnGap={2}>
              <Icon sx={{ color: 'alternate.main' }}>account_balance_wallet</Icon>
              <Box>
                <Typography variant="h4" color="dark-text.main">
                  Available credits : RM {creditBalance}.00
                </Typography>
                {data.price_summary.total_price > creditBalance ? (
                  <Typography variant="h4" color="error.main">
                    Insufficient credit balance
                  </Typography>
                ) : null}
              </Box>
            </Box>
            <Box>
              {creditBalance > data.price_summary.total_price ? (
                <AdxButton variant={'outlined'} size="standard" onClick={goToCreditTopUp}>
                  <Icon>add</Icon>
                  Topup
                </AdxButton>
              ) : (
                <AdxButton variant={'contained'} size="standard" onClick={goToCreditTopUp}>
                  <Icon>add</Icon>
                  Topup
                </AdxButton>
              )}
            </Box>
          </Box>
          <Typography
            variant="h3"
            color="dark-text.main"
            marginTop={4}
            sx={{
              fontWeight: 'bold',
            }}
          >
            Credit deduction summary
          </Typography>
          <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={4}>
            <Typography variant="h4" color="light-gray-text.main">
              {data.price_summary.applicant_with_cv_count} candidates with resume only
            </Typography>
            <Typography variant="h4" color="light-gray-text.main">
              -RM{data.price_summary.applicant_with_cv_count * data.price_summary.cv_price}.00
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginTop={4}
            marginBottom={2}
          >
            <Typography variant="h4" color="light-gray-text.main">
              {data.price_summary.applicant_with_cv_video_count} candidate with resume and video
              interview
            </Typography>
            <Typography variant="h4" color="light-gray-text.main">
              -RM
              {data.price_summary.applicant_with_cv_video_count * data.price_summary.cv_video_price}
              .00
            </Typography>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2}>
            <Typography
              variant="h4"
              color="dark-text.main"
              sx={{
                fontWeight: 'bold',
              }}
            >
              Total
            </Typography>
            <Typography
              variant="h4"
              color="dark-text.main"
              sx={{
                fontWeight: 'bold',
              }}
            >
              -RM{data.price_summary.total_price}.00
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginTop={8}
            marginBottom={2}
          >
            <Typography variant="h4" color="light-gray-text.main">
              Available credit
            </Typography>
            {creditBalance > data.price_summary.total_price ? (
              <Typography variant="h4" color="light-gray-text.main">
                RM{creditBalance}.00
              </Typography>
            ) : (
              <Typography variant="h4" color="light-gray-text.main">
                (Insufficient) RM{creditBalance}.00
              </Typography>
            )}
          </Box>
          {data.price_summary.total_price > creditBalance ? (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginTop={2}
              marginBottom={2}
            >
              <Typography variant="h4" color="light-gray-text.main">
                Insufficient credit amount
              </Typography>
              <Typography variant="h4" color="error.main">
                RM{data.price_summary.total_price - creditBalance}.00
              </Typography>
            </Box>
          ) : null}
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2}>
            <Typography variant="h4" color="light-gray-text.main">
              Balance after deduction
            </Typography>
            {creditBalance > data.price_summary.total_price ? (
              <Typography variant="h4" color="light-gray-text.main">
                RM{data.new_balance}.00
              </Typography>
            ) : (
              <Typography variant="h4" color="light-gray-text.main">
                -
              </Typography>
            )}
          </Box>
          <Box marginTop={6} display="flex" flexDirection="column" alignItems="center">
            <Box display="flex" columnGap={0.5} marginBottom={1}>
              <Typography variant="body2" color="light-gray-text.main">
                By clicking “Pay now”, you agree to our
              </Typography>
              <TermAndCondition />
            </Box>
            {creditBalance > data.price_summary.total_price ? (
              <Box>
                {payWithCreditIsLoading ? (
                  <AdxButton
                    variant={'contained'}
                    isLoading
                    size="standard"
                    sx={{ width: 500 }}
                  ></AdxButton>
                ) : (
                  <AdxButton
                    variant={'contained'}
                    onClick={handlePayment}
                    size="standard"
                    sx={{ width: 500 }}
                  >
                    Pay Now
                  </AdxButton>
                )}
              </Box>
            ) : (
              <AdxButton variant={'contained'} disabled size="standard" sx={{ width: 500 }}>
                Pay Now
              </AdxButton>
            )}
            <AdxButton
              variant={'ghost'}
              size="standard"
              sx={{ width: 500, marginTop: 1 }}
              onClick={returnToCart}
            >
              Return to cart
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export default PaymentPage
